/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'delete': {
    width: 31,
    height: 31,
    viewBox: '0 0 31 31',
    data: '<g _fill="#D71254" fill-rule="evenodd"><circle pid="0" fill-opacity=".097" cx="15.5" cy="15.5" r="15.5"/><path pid="1" d="M22 9.2h-3L18.143 8h-4.286L13 9.2h-3v1.2h12V9.2zM11.2 20.857a1.577 1.577 0 001.6 1.543h6.4a1.577 1.577 0 001.6-1.543V11.6h-9.6v9.257z"/></g>'
  }
})
